import { render, staticRenderFns } from "./ReportDataAreaNew.vue?vue&type=template&id=387e7335&"
import script from "./ReportDataAreaNew.vue?vue&type=script&lang=js&"
export * from "./ReportDataAreaNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports